import { startTransition, useEffect } from 'react';
import { techblogPage, techblogSearchKeyword } from '../techblog.state';
import { useAtom, useSetAtom } from 'jotai';
import { useScrollBehavior, useScrollInit } from '@/utils/hook';

import { mixpanelTrack } from '@/utils/mixpanel';
import themeVariables from '@/styles/themeVariables';
import { useMediaQuery } from '@mantine/hooks';
import { useReplaceQueryParams } from '@/utils/utils';

export const useHandleBlogKeyword = ([preKeyword, setPreKeyword]) => {
  const { queryParams, urlSearchParams, setQueryParams } =
    useReplaceQueryParams();

  const setTechblogPage = useSetAtom(techblogPage);
  const [{ tag }, setTechblogKeyword] = useAtom(techblogSearchKeyword);
  const isMobile = useMediaQuery(themeVariables.layout.mobile);

  useEffect(() => {
    setTechblogKeyword({
      keyword: queryParams.get('keyword') || '',
      tag: queryParams.get('tag') || '',
    });
  }, [queryParams.get('keyword'), queryParams.get('tag')]);

  const handleTagChange = (tag) => {
    if (!tag) return;

    setTechblogPage(1);
    setTechblogKeyword({
      keyword: '',
      tag: tag,
    });

    urlSearchParams.delete('keyword');
    urlSearchParams.delete('company_id');
    urlSearchParams.set('page', 1 + '');
    urlSearchParams.set('tag', tag);
    setQueryParams(urlSearchParams);

    useScrollBehavior(!isMobile ? 0 : 1300);

    startTransition(() => {
      mixpanelTrack('TechblogListPage_SideSearchBox_Techstack', 'Searched', {
        id: tag,
      });
    });
  };

  const handleKeywordChange = () => {
    setTechblogPage(1);
    setTechblogKeyword({
      keyword: preKeyword,
      tag: '',
    });

    preKeyword
      ? urlSearchParams.set('keyword', preKeyword)
      : urlSearchParams.delete('keyword');
    urlSearchParams.delete('company_id');
    urlSearchParams.delete('tag');
    urlSearchParams.set('page', 1 + '');
    setQueryParams(urlSearchParams);

    useScrollBehavior(!isMobile ? 0 : 1150);
  };

  const handleInitKeyword = () => {
    setTechblogPage(1);
    setTechblogKeyword({
      keyword: '',
      tag: '',
    });
    setPreKeyword('');

    urlSearchParams.delete('tag');
    urlSearchParams.delete('keyword');
    urlSearchParams.set('page', 1 + '');
    setQueryParams(urlSearchParams);

    useScrollInit();
  };

  const handleEnterKeyword = (e) => {
    if (e.key === 'Enter') {
      handleKeywordChange();
    }
  };

  return {
    tag,
    handleTagChange,
    handleKeywordChange,
    handleInitKeyword,
    handleEnterKeyword,
  };
};
